var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiRsPaperPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1669_6482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4437 6.66874C1.10885 6.76442 0.804795 6.94586 0.561607 7.19513C0.318419 7.44439 0.144531 7.75284 0.0571494 8.08994C-0.0302325 8.42704 -0.0280796 8.78112 0.063395 9.11713C0.15487 9.45315 0.332495 9.75945 0.578696 10.0057L3.9907 13.4137V19.9997H10.5837L14.0187 23.4297C14.2031 23.6157 14.4224 23.7634 14.664 23.8643C14.9056 23.9652 15.1648 24.0173 15.4267 24.0177C15.5988 24.0174 15.7702 23.9952 15.9367 23.9517C16.2737 23.8669 16.5823 23.6947 16.8316 23.4526C17.0809 23.2105 17.262 22.9071 17.3567 22.5727L23.9907 0.020752L1.4437 6.66874ZM1.9997 8.59174L19.0277 3.57175L5.9927 16.5857V12.5857L1.9997 8.59174ZM15.4397 22.0157L11.4127 17.9997H7.4127L20.4457 4.97775L15.4397 22.0157Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1669_6482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsPaperPlane);
export default __webpack_public_path__ + "static/media/fi-rs-paper-plane.a87aba3b.svg";
export { ForwardRef as ReactComponent };